export default __webpack_public_path__ + "static/media/staff.0a5cdee4.PNG";